import { useParams } from 'react-router-dom';
import { Typography } from 'antd';
import DesignDocumentTable from '@/components/requirements/DesignDocumentTable';
import { CopyExternalLinkButton } from '@/components/packages/CopyExternalLinkButton';

const { Title } = Typography;

const DesignMaterialManagement: React.FC = () => {
  const { projectId } = useParams<{ projectId: string }>();
  const numericProjectId = Number(projectId);

  if (!projectId || isNaN(numericProjectId)) {
    return <div>无效的项目 ID</div>;
  }

  return (
    <div className="p-6">
      {/* margin:0 是为了让标题与复制按钮垂直居中对齐，原标题的下边距挪到容器上 */}
      <div className="flex items-center gap-1" style={{ marginBottom: '0.5em' }}>
        <Title level={3} style={{ margin: 0 }}>设计材料</Title>
        <CopyExternalLinkButton kind="current" />
      </div>
      <div className="mt-4">
        <DesignDocumentTable projectId={numericProjectId} />
      </div>
    </div>
  );
};

export default DesignMaterialManagement;
